<div class="block-gallery">
  <h1 class="block-gallery-title">{{ title }}</h1>
  <button type="button" class="block-gallery-toggle-button" [ngClass]="{ 'is--active': active }" (click)="toggle.emit()">
    <span class="icon is--icon-min">
      <svg class="icon-svg">
        <use xlink:href="assets/gfx/svg-sprite.svg#icon-min"></use>
      </svg>
    </span>
    <span class="icon is--icon-plus">
      <svg class="icon-svg">
        <use xlink:href="assets/gfx/svg-sprite.svg#icon-plus"></use>
      </svg>
    </span>
  </button>

  <div class="block-collapsable">
    <ng-content></ng-content>
  </div>
</div>
